import React, { createContext, useContext, useState } from 'react';

// MCPContext provides tool invocation and loading/error states.
const MCPContext = createContext();

export const MCPProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [lastError, setLastError] = useState(null);

  // Generic function to invoke an MCP tool via backend API.
  const invokeMCP = async (toolName, parameters = {}) => {
    setLoading(true);
    setLastError(null);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/mcp/invoke`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          // Optionally, include frontend JWT or auth header here if your API requires it
        },
        body: JSON.stringify({ tool: toolName, parameters }),
      });
      if (!response.ok) {
        throw new Error(`MCP tool invocation failed: HTTP ${response.status}`);
      }
      const result = await response.json();
      setLoading(false);
      return result;
    } catch (err) {
      setLastError(err.message);
      setLoading(false);
      return null;
    }
  };

  return (
    <MCPContext.Provider value={{ invokeMCP, loading, lastError }}>
      {children}
    </MCPContext.Provider>
  );
};

// For use in custom hooks
export const useMCPContext = () => useContext(MCPContext);
